/// <reference path="../../../Core/DataTypes/types.js" />
import ImageGallery from './ImageGallery';
import { useTranslation } from 'react-i18next';
import { useGlobal } from '../../../Core/GlobalState/Store';
import Currencies from '../../../Core/Enums/Currencies';
import { addVat } from '../../../Core/Services/PaymentService';

export default function ContainerInfoComponent({
  roomList,
  selectedSize,
  selectedLevel,
  setSelectedLevel,
  showPlacementBody,
  handleNext,
  onClose,
}) {
  const { t, i18n } = useTranslation();
  const { room, setRoom } = useGlobal();

  async function setHighestDwellTimeRoom() {
    const filteredRooms = roomList.filter(
      room =>
        selectedSize.sizeTypes.includes(room.ItemSizeType.Name) &&
        room.level === selectedLevel
    );

    if (filteredRooms.length === 0) return;

    const highestDwellTimeRoom = filteredRooms.reduce((prev, current) => {
      const prevDwellTime = prev.DateFrom
        ? new Date(prev.DateFrom) - new Date()
        : -Infinity;

      const currentDwellTime = current.DateFrom
        ? new Date(current.DateFrom) - new Date()
        : -Infinity;
      return prevDwellTime < currentDwellTime ? prev : current;
    });

    await setRoom(highestDwellTimeRoom);
    handleNext();
  }

  return (
    <div className="w-full">
      <div className="!border !border-solid border-gray-300">
        {showPlacementBody && (
          <div className="py-4 text-center">
            <div>
              <div className="text-center text-base">{selectedSize.title}</div>
              <div className="text-center font-bold text-xl">
                {room && (room.Length * room.Width).toFixed(2)}
                {!room && selectedSize.sizeInSquareMeters} m²
              </div>
            </div>
            <div className="text-center mt-4 text-base">
              {room != null && (
                <div>
                  {t('price')}{' '}
                  {addVat(room.SelfStoreMonthPrice).toLocaleString(
                    i18n.language,
                    {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }
                  )}
                  {room.SelfStoreMonthPriceUniCurrency &&
                    ' ' +
                      Currencies.getCodeByValue(
                        room.SelfStoreMonthPriceUniCurrency
                      )}
                  .
                </div>
              )}
              {showPlacementBody && room && room.ItemSizeType && (
                <div className="p-4 mt-4 bg-selectblue !border !border-solid border-borderblue">
                  <div className="text-sm font-bold">
                    {room.Prefix} {room.Number} {t('is_chosen')}
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
        <div className="">
          <div className="mt-auto flex justify-between">
            <ImageGallery
              images={selectedSize.images || []}
              altText={selectedSize.title}
            />
          </div>
        </div>
        <div className="p-8 flex flex-col gap-6 !border-t !border-gray-400 !border-1">
          <div className="font-bold text-xl flex justify-between items-center gap-4">
            <div>
              {selectedSize && !showPlacementBody && selectedSize.title}
            </div>
            <div>
              {selectedSize &&
                !showPlacementBody &&
                t('container_from_price', {
                  price: addVat(selectedSize.fromPrice).toLocaleString(
                    i18n.language,
                    {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }
                  ),
                  currency: Currencies.getCodeByValue(selectedSize.currency),
                })}
            </div>
          </div>
          <div className="text-base">
            {selectedSize && selectedSize.description}
          </div>
          <div>
            <div className="flex justify-between items-center">
              <div className="flex gap-4 flex-wrap">
                <div className="text-sm font-normal !border !border-solid border-gray-300 px-2 py-1">
                  {t('length_letter')}: {selectedSize && selectedSize.length} m
                </div>
                <div className="text-sm font-normal !border !border-solid border-gray-300 px-2 py-1">
                  {t('width_letter')}: {selectedSize && selectedSize.width} m
                </div>
                <div className="text-sm font-normal !border !border-solid border-gray-300 px-2 py-1">
                  {t('height_letter')}: {selectedSize && selectedSize.height} m
                </div>
                <div className="text-sm font-normal !border !border-solid border-gray-300 px-2 py-1">
                  {selectedSize &&
                    (selectedSize.length * selectedSize.width).toFixed(2)}{' '}
                  m²
                </div>
              </div>
              <div className="text-red-300 text-sm">
                {selectedSize &&
                  !showPlacementBody &&
                  selectedSize.availableAmount + ' ' + t('units_available')}
              </div>
            </div>
          </div>
          <div>
            <div className="!border !border-solid border-gray-300 p-6 mt-6">
              <div className="flex justify-between items-center">
                <div className="flex">
                  <input
                    style={{
                      accentColor: '#233F72',
                      width: '20px',
                      height: '20px',
                      marginRight: '8px',
                    }}
                    type="radio"
                    name={'level' + Math.random()}
                    checked={selectedLevel === 0}
                    disabled={
                      selectedSize.levelPrice[0] == null ||
                      selectedSize.levelPrice[0] == 0
                    }
                    onChange={() => setSelectedLevel(0)}
                  />
                  <div className="font-bold text-sm">{t('ground_floor')}</div>
                  <div className="text-sm">
                    {selectedSize &&
                    selectedSize.levelPrice &&
                    selectedSize.levelPrice[0] ? (
                      <>
                        :{' '}
                        {t('container_from_price', {
                          price: addVat(
                            selectedSize.levelPrice[0]
                          ).toLocaleString(i18n.language, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }),
                          currency: Currencies.getCodeByValue(
                            selectedSize.currency
                          ),
                        })}
                      </>
                    ) : (
                      <span className="text-gray-400 ml-1">
                        {t('no_units_available')}
                      </span>
                    )}
                  </div>
                </div>
                {/*  {selectedSize.levelAmount > 1 && (
                  <div className="tooltip text-sm">
                    info
                    <span className="tooltiptext hidden md:block p-2">
                      {t("select_floor_info_text")}
                    </span>
                  </div>
                )} */}
              </div>
              <div className="flex mt-3">
                {selectedSize && selectedSize.levelAmount > 1 && (
                  <>
                    <input
                      style={{
                        accentColor: '#233F72',
                        width: '20px',
                        height: '20px',
                        marginRight: '8px',
                      }}
                      type="radio"
                      name={'level' + Math.random()}
                      checked={selectedLevel == 1}
                      disabled={
                        selectedSize.levelPrice[1] == null ||
                        selectedSize.levelPrice[1] == 0
                      }
                      onChange={() => setSelectedLevel(1)}
                    />
                    <div className="font-bold text-sm">
                      {selectedSize.levelAmount - 1} {t('floor')}
                    </div>
                    <div className="text-sm">
                      {selectedSize &&
                      selectedSize.levelPrice &&
                      selectedSize.levelPrice[1] ? (
                        <>
                          :{' '}
                          {t('container_from_price', {
                            price: addVat(
                              selectedSize.levelPrice[1]
                            ).toLocaleString(i18n.language, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }),
                            currency: Currencies.getCodeByValue(
                              selectedSize.currency
                            ),
                          })}
                        </>
                      ) : (
                        <span className="text-gray-400 ml-1">
                          {t('no_units_available')}
                        </span>
                      )}
                    </div>
                  </>
                )}
              </div>
            </div>
            <div className="flex w-full">
              {onClose && (
                <div
                  onClick={onClose}
                  className="w-1/2 bg-gray-200 h-[60px] align-center flex justify-center items-center hover:cursor-pointer hover:bg-gray-300"
                >
                  <div className="text-gray-700 font-bold">{t('close')}</div>
                </div>
              )}
              {showPlacementBody && (
                <div
                  onClick={() => handleNext()}
                  className={`${onClose ? 'w-1/2' : 'w-full'} bg-primaryblue h-[60px] align-center flex justify-center items-center hover:cursor-pointer hover:bg-primaryorange`}
                >
                  <div className="text-white font-bold">{t('go_next')}</div>
                </div>
              )}
              {!showPlacementBody && (
                <div
                  onClick={() => setHighestDwellTimeRoom()}
                  className={`${onClose ? 'w-1/2' : 'w-full'} bg-primaryblue h-[60px] align-center flex justify-center items-center hover:cursor-pointer hover:bg-primaryorange`}
                >
                  <div className="text-white font-bold">{t('choose')}</div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
